import "core-js";
import "regenerator-runtime/runtime";
import eotwJSXFactory from "base/eotwJSXFactory";
import GlobalEvents from "base/GlobalEvents";

import "jquery-serializejson";
import "settings";

import Page from "webPage/Page";
import handleHeroElements from "elements/handleHeroElements";
import {handleSliders} from "util/handleSliders";
import VideoModal from "modal/VideoModal";
import {loadGoogleMap} from "util/GoogleMap";
import {handleStickyNav} from "util/handleStickyNav";
import {handleNewsletterForms} from "util/handleNewsletterForms";
import ZayerModal from "modal/ZayerModal";
import CookieHelper from "base/CookieHelper";

window.$ = jQuery;

$(function () {
    if (window.jsLoadTimeout) {
        clearTimeout(window.jsLoadTimeout);
    }

    document.documentElement.setAttribute('data-useragent', navigator.userAgent);
    if (!!window.MSInputMethodContext && !!document.documentMode) {
        $('html').addClass('ie11');
    }

    Page.init();
    handleStickyNav();

    let $hero_elements = $('.js-hero');
    if ($hero_elements.length > 0) {
        handleHeroElements($hero_elements);
    }

    $('body').on('click', '.js-footer-accordion-btn', function () {
        if ($(window).outerWidth() >= 760) {
            return false;
        }
        $(this).parents('.js-footer-accordion').toggleClass('footer-accordion--active').find('.js-footer-accordion-body').stop().slideToggle();
    }).on('click', '.js-accordion-title', function () {
        $(this).parents('.js-accordion-item').toggleClass('accordion--active').find('.js-accordion-body').stop().slideToggle(300);
    }).on('click', '.js-show-navigation', function () {
        $('body').addClass('show-nav');
        $('.js-header').css("transform", "");
        GlobalEvents.emit('navigation.open');
        return false;
    }).on('click', '.js-hide-navigation', function () {
        $('body').removeClass('show-nav');
        GlobalEvents.emit('navigation.close');
    }).on('click', '.js-show-dropdown', function () {
        $(this).parent().find('.dropdown').addClass('dropdown--active');
    }).on('click', '.js-hide-dropdown', function () {
        $(this).parents('.dropdown').removeClass('dropdown--active');
    }).on('click', '.js-play-video', function () {
        let id = $(this).attr('data-video-id');
        let provider = parseInt($(this).attr('data-provider'));
        let modal = new VideoModal(id, provider);
        modal.show();

        return false;
    }).on('click', '.js-show-sub-nav', function () {
        $(this).toggleClass('nav-icon--active');
        $('.js-more-dropdown').toggleClass('active');
        $('.js-header').toggleClass('header--visible-forced');

        return false;
    }).on('click', '.js-scroll-to', function () {
        let target = $(this).attr('href');

        $('html, body').animate({
            scrollTop: $(target).offset().top - 50
        }, 500);
        return false;
    }).on('click', '.js-show-modal', function () {
        let id = $(this).attr('data-modal-id');
        $('.js-modal[data-modal-id="' + id + '"]').addClass('modal--active');
    }).on('click', '.js-close-modal', function () {
        $(this).parents('.modal').removeClass('modal--active');
    }).on("click", () => {
        GlobalEvents.emit("popup-close");
    }).on('click', 'a[href^="tel:"]', function () {
        gtag_report_tel_conversion($(this).attr('href'));
    }).on('click', 'a[href^="mailto:"]', function (e) {
        return gtag_report_mail_conversion($(this).attr('href'));
    }).on('click', 'a[href^="mailto:"]', function (e) {
        return gtag_report_mail_conversion($(this).attr('href'));
    }).on('click', 'a[href*="/contact-us/"]', function (e) {
        return gtag_report_contact_click($(this).attr('href'));
    }).on('click', '.js-interactive-map-tooltip', function () {
        $(this).closest('.interactive-map__point').addClass('interactive-map__point--active');
        $('.js-interactive-map').addClass('interactive-map--active');
        $('body').addClass('interactive-map-active');
        $('.tooltip--interactive-map').removeClass('tooltip--active');
        $(this).closest('.interactive-map__point').find('.tooltip--interactive-map').addClass('tooltip--active');
    }).on('click', '.js-close-interactive-tooltip', function () {
        $('.interactive-map__point--active').removeClass('interactive-map__point--active');
        $(this).closest('.tooltip--active').removeClass('tooltip--active');
        $('.js-interactive-map').removeClass('interactive-map--active');
        $('body').removeClass('interactive-map-active');
    });


    $(document).on('gform_confirmation_loaded', function (event, formId) {

        if (formId === 4 /* Contact */) {
            $('#gf_' + formId).parent('.form-container').addClass('form-container--form-submitted');
            try {
                gtag('event', 'submit_lead', {
                    'event_category': 'general', 'event_label': 'enquiry_form', 'value': '0'
                });
                dataLayer.push({'event':'contact-submit'});
            } catch (e) {
                console.log(e);
            }
        } else if (formId === 8 /* Newsletter */) {
            $('#gf_' + formId).parents('.signup-form').addClass('signup-form--submitted');
        } else if (formId === 9 /* Request a Brochure */) {
            try {
                gtag('event', 'submit_lead', {
                    'event_category': 'general', 'event_label': 'request_brochure', 'value': '0'
                });
            } catch (e) {
                console.log(e);
            }
        } else if (formId === 11 /* Get your copy of Insight Magazine */) {
            $('#gf_' + formId).parents('.cta').addClass('cta--submitted');
        }

        if ($('#gf_' + formId).parents('.js-download-magazine').length > 0 && 'undefined' !== typeof window.magazine_download_url) {
            let anchor = document.createElement("a");
            anchor.href = window.magazine_download_url;
            anchor.download = window.magazine_download_name;

            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }
    });

    if ($('.js-google-map').length > 0) {
        loadGoogleMap($('.js-google-map'));
    }

    //Remove display none from modal elements so they can be shown
    $('.js-product-brochure-modal, .js-arrange-demo-modal, .js-modal').removeAttr('style');

    handleSliders();
    handleNewsletterForms();
});


function handleZayerModal() {

    if (CookieHelper.get('zayer-modal-dismissed')) {
        return;
    }

    //don't show modal on zayer pages
    if (new RegExp('/zayer/?').test(window.location.pathname)) {
        return;
    }

    //don't show modal on product pages
    if (new RegExp('/product/?').test(window.location.pathname)) {
        return;
    }

    (new ZayerModal()).show();
}

function gtag_report_contact_click(url) {
    try {
        gtag('event', 'submit_lead', {
            'event_category': 'general', 'event_label': 'contact', 'value': '0',
        });
        dataLayer.push({
            'event': 'enquire-now-click', 'eventCallback': function () {
                window.location.href = url;
            }
        });
    } catch (e) {
    }
    return false;
}

function gtag_report_mail_conversion(url) {
    try {
        gtag('event', 'submit_lead', {
            'event_category': 'general', 'event_label': 'email', 'value': '0',
        });
        dataLayer.push({
            'event': 'email-click', 'eventCallback': function () {
                window.location.href = url;
            }
        });
    } catch (e) {
    }
    return false;
}

function gtag_report_tel_conversion(url) {
    try {
        gtag('event', 'submit_lead', {
            'event_category': 'general', 'event_label': 'telephone', 'value': '0'
        });
        dataLayer.push({
            'event': 'phone-click', 'eventCallback': function () {
                window.location.href = url;
            }
        });
    } catch (e) {
    }
}

export function svg_include(icon, suffix = '') {
    return '<svg><use xlink:href="/wp-content/themes/mills-cnc/includes/svg-icons/' + icon + '.svg#content"></use></svg>';
}

window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;
